import { Component } from '@angular/core';

@Component({
  selector: 'spend-chart-placeholder',
  styleUrls: ['./spend-chart-placeholder.component.scss'],
  templateUrl: './spend-chart-placeholder.component.html'
})
export class SpendChartPlaceholderComponent {}
